export const photoPrivacyMigrations = [
  {
    id: '040_photo_visibility_events',
    sql: `
      ALTER TABLE relationship_events
        DROP CONSTRAINT relationship_events_event_type_check;
      ALTER TABLE relationship_events
        ADD CONSTRAINT relationship_events_event_type_check CHECK (event_type IN (
          'request_sent','request_accepted','request_declined','request_withdrawn',
          'photo_requested','photo_approved','photo_declined','photo_shared','photo_hidden',
          'meeting_proposed','meeting_confirmed','meeting_cancelled','meeting_completed',
          'call_joined','call_left'
        ));
    `,
  },
] as const;
